class NSSContact extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      phoneGroup: this.querySelector(`.nss-contact__phone-group`),
      formDialCodeButton: this.querySelector(`#ContactFormDialCodeButton`),
      spanFlag: this.querySelector(`.nss-phone-group-flag`),
      spanCode: this.querySelector(`.nss-phone-group-code`),
      formDialCodeSelect: this.querySelector(`#ContactFormDialCodeSelect`),
      formPhoneOnly: this.querySelector(`#ContactFormPhoneOnly`),
      formPhone: this.querySelector(`#ContactFormPhone`),
      formInquiryType: this.querySelector(`#ContactFormInquiryType`),
      phoneSelectGroup: this.querySelector(`.nss-phone-select-group`),
      phoneLabel: this.querySelector(`.nss-contact__phone-group ~ label`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Contact] Connected.`);

    this.initFlagSelect();
    this.updateFormPhone();
    this.els.phoneGroup.style.display = `flex`;
    this.els.formPhone.setAttribute(`type`, `hidden`);

    this.els.formDialCodeSelect.addEventListener(`change`, this.updateFormPhone.bind(this));
    this.els.formPhoneOnly.addEventListener(`keyup`, this.updateFormPhone.bind(this));

    this.updateInquiryFromURL();
    this.els.formInquiryType.addEventListener(`change`, this.updateInquiryFromSelect.bind(this));
  }

  updateInquiryFromURL() {
    const url = new URL(window.location);
    const id = url.searchParams.get(`inquiry`);
    if (id) {
      const optionEl = this.querySelector(`[nss-inquiry-id="${id}"]`);
      if (optionEl) {
        this.els.formInquiryType.value = optionEl.value;
      } else {
        if (this.debug) console.warn(`[NSS][Contact] No option matching inquiry id ${id}!`);
      }
    } else {
      this.updateInquiryFromSelect();
    }
  }

  updateInquiryFromSelect() {
    const optionEl = this.els.formInquiryType.options[this.els.formInquiryType.selectedIndex];
    const id = optionEl.getAttribute(`nss-inquiry-id`);
    if (id) {
      const url = new URL(window.location);
      url.searchParams.set(`inquiry`, id);
      history.pushState(null, "", url);
    }
  }

  updateFormPhone() {
    const code = this.els.formDialCodeSelect.value;
    const entry = this.els.formPhoneOnly.value;
    this.els.formPhone.value = `${code} ${entry}`;
    this.updateDialCodeButton();
    this.els.formDialCodeSelect.style.width = `${this.els.formDialCodeButton.clientWidth}px`;
    this.updatePhoneLabelPosition();
  }

  updatePhoneLabelPosition() {
    if (!this.els.phoneLabel || !this.els.phoneSelectGroup) return;
    const width = this.els.phoneSelectGroup.offsetWidth;
    if (width) this.els.phoneLabel.style.left = `${width + 5}px`;
  }

  updateDialCodeButton() {
    const optionEl = this.els.formDialCodeSelect.options[this.els.formDialCodeSelect.selectedIndex];
    if (optionEl) {
      const flagEmoji = this.getFlagEmoji(optionEl.getAttribute(`nss-country-code`));
      this.els.spanFlag.innerHTML = flagEmoji;
    }

    this.els.spanCode.innerHTML = this.els.formDialCodeSelect.value;
  }

  initFlagSelect() {
    fetch(this.els.formDialCodeSelect.getAttribute(`nss-data-url`))
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        data.forEach((country, index) => {
          country.callingCodes.forEach((callingCode) => {
            this.createCountryOption(country, callingCode, index);
          });
        });
      });
  }

  createCountryOption(country, callingCode, index) {
    const flagEmoji = this.getFlagEmoji(country.alpha2Code);
    const optionEl = document.createElement(`option`);
    const code = `${callingCode ? `+${callingCode}` : ""}`;
    optionEl.innerHTML = `${flagEmoji} ${country.name} ${code}`;
    optionEl.value = `${code}`;
    optionEl.setAttribute(`nss-country-code`, country.alpha2Code);
    this.els.formDialCodeSelect.appendChild(optionEl);
    if (country.alpha2Code === this.els.formDialCodeSelect.getAttribute(`nss-current-country`)) {
      // this.els.formDialCodeSelect.value = code; // There are duplicated values
      this.els.formDialCodeSelect.options.selectedIndex = index + 1;
    }
    this.els.formDialCodeSelect.dispatchEvent(new Event("change"));
  }

  // https://dev.to/jorik/country-code-to-flag-emoji-a21
  getFlagEmoji(countryCode) {
    const codePoints = countryCode
      .toUpperCase()
      .split("")
      .map((char) => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  }
}

let elementName = `nss-contact`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSContact);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
